<template>
  <div>
    <search-nav @handleSearch="handleSearch">
      <search-nav-year-month class="mr-4" label="대상기간" v-model="search.date" :useAllYear="false" monthType="each" />
      <div class="flex items-center">
        <div class="label-text mr-4">학교(기관)명</div>
        <ml-input v-model="search.fieldName" class="w-full flex-1" />
      </div>
    </search-nav>

    <vs-row class="mb-4">
      <vs-col class="flex" vs-justify="flex-end">
        <vs-button color="secondary" type="border" @click="excelUpload = true">Excel 다운로드</vs-button>
      </vs-col>
    </vs-row>

    <!-- table -->
    <div class="overflow-x-auto" style="margin-bottom: 60px">
      <div style="min-width: 1400px">
        <vs-row class="border">
          <vs-col>
            <div class="border-top border-left border-right table-display" style="grid-template-columns: 125px 160px 160px 160px 1fr 1fr 1fr 1fr 1fr">
              <span class="title table-center border-left" style="grid-row: 1/3; grid-column: 1">연번</span>
              <span class="title table-center border-left" style="grid-row: 1/3; grid-column: 2">연도</span>
              <span class="title table-center border-left" style="grid-row: 1/3; grid-column: 3">구분</span>
              <span class="title table-center border-left" style="grid-row: 1/3; grid-column: 4">급별</span>
              <span class="title table-center border-left" style="grid-row: 1/3; grid-column: 5">학교(기관)명</span>
              <span class="title table-center border-left border-bottom" style="grid-row: 1/2; grid-column: 6/10">업무 분야별 이수 현황(시간)</span>
              <span class="title table-center border-left" style="grid-row: 2/3; grid-column: 6">급식</span>
              <span class="title table-center border-left" style="grid-row: 2/3; grid-column: 7">시설관리</span>
              <span class="title table-center border-left" style="grid-row: 2/3; grid-column: 8">미화</span>
              <span class="title table-center border-left" style="grid-row: 2/3; grid-column: 9">통학차량</span>
            </div>
          </vs-col>
        </vs-row>

        <vs-row class="">
          <vs-col>
            <div v-for="(data, dataIndex) in form.list"
                 :key="`${data.학교명}_${getNo(dataIndex)}`"
                 class="border-top border-left border-right table-content"
                 style="grid-template-columns: 125px 160px 160px 160px 1fr 1fr 1fr 1fr 1fr">
              <span class="table-center border-left">{{ getNo(dataIndex) }}</span>
              <span class="table-center border-left">{{ search.date.year }}</span>
              <span class="table-center border-left">{{ data.구분 }}</span>
              <span class="table-center border-left">{{ data.급별 }}</span>
              <span class="table-center border-left">{{ data.학교명 }}</span>
              <span class="table-center border-left">{{ data.급식 }}</span>
              <span class="table-center border-left">{{ data.시설관리 }}</span>
              <span class="table-center border-left">{{ data.미화 }}</span>
              <span class="table-center border-left">{{ data.통학차량 }}</span>
            </div>
          </vs-col>
        </vs-row>

        <vs-row class="">
          <vs-col class="border-bottom">
            <div class="border-top border-left border-right table-content"
                 style="grid-template-columns: 125px 160px 160px 160px 1fr 1fr 1fr 1fr 1fr">
              <span class="table-center border-left" style="grid-column: 1/6;">계</span>
              <span class="table-center border-left">{{ calcTotal('급식') }}</span>
              <span class="table-center border-left">{{ calcTotal('시설관리') }}</span>
              <span class="table-center border-left">{{ calcTotal('미화') }}</span>
              <span class="table-center border-left">{{ calcTotal('통학차량') }}</span>
            </div>
          </vs-col>
        </vs-row>
      </div>
    </div>

    <!-- paging -->
    <div class="vs-con-table">
      <div class="con-pagination-table vs-table--pagination">
        <k-pagination
          :total="form.list.length > 0 ? Math.floor((form.list.length - 1) / search.perPage) + 1 : 1"
          :max-items="5"
          v-model="search.cursorPage"
          @change="onChangePage"></k-pagination>
      </div>
    </div>

    <popup-excel-download
      v-model="excelUpload"
      :list="form.list"
      title="관리감독자 정기 교육 모니터링"/>
  </div>
</template>

<script>
import SearchNavYearMonth from "@/components/nav/SearchNavYearMonth.vue";
import SearchNav from "@/components/nav/SearchNav.vue";
import KPagination from "@/components/kPagination/kPagination.vue";
import PopupExcelDownload from "@/popup/PopupExcelDownload.vue";
import HttpRequest from "@/util/HttpRequest";

export default {
  name: "monitoring",
  components: {PopupExcelDownload, KPagination, SearchNav, SearchNavYearMonth},

  computed: {
    projectId() {
      return this.$route.params.proj_id;
    },
    집합계 () {
      if (this.form.list.length > 0) {
        let sum = 0;
        for (const data of this.form.list) {
          sum += Number(`${data['집합']}`);
        }
        return sum;
      }
      return 0;
    },
    원격계 () {
      if (this.form.list.length > 0) {
        let sum = 0;
        for (const data of this.form.list) {
          sum += Number(`${data['원격']}`);
        }
        return sum;
      }
      return 0;
    }
  },
  data() {
    return {
      search: {
        date: { year: new Date().getFullYear(), month: '', half: '' },
        fieldName: '',
        cursorPage: 1,
        perPage: 100,
      },
      form: {
        total: 2,
        list: [],
      },
      excelUpload: false,
    }
  },
  methods: {
    loadData() {
      const boardId = 674
      const option = {
        params: {
          targetYear: this.search.date.year,
          perPage: this.search.perPage,
          page: this.search.cursorPage,
        }
      }

      if (this.search.fieldName) {
        option.params.fieldName = `%${this.search.fieldName}%`
      }

      if (this.search.date.month) {
        option.params.beginMonth = this.search.date.month
        option.params.endMonth = this.search.date.month
      }

      HttpRequest.get(`/api/v1/summary/post/${boardId}`, option)
        .then(response => {
          const datas = response.data;
          if (datas.length > 0) {
            const list = [];
            for (const data of datas) {
              const 구분데이터 = data['구분'];
              const 구분키 = Object.keys(구분데이터);
              for (const key of 구분키) {
                const keyData = 구분데이터[key];
                list.push({
                  '급별': data.facility_cat3,
                  '구분': key,
                  '학교명': data.field_name,
                  '급식': keyData['분야_급식_시간'],
                  '시설관리': keyData['분야_시설관리_시간'],
                  '미화': keyData['분야_미화_시간'],
                  '통학차량': keyData['분야_통학차량_시간'],
                })
              }
            }
            this.form.list = list;
          } else {
            this.form.list = [];
          }
        }).catch(err => {  })
    },
    getNo (index) {
      // return this.form.total - ((this.search.cursorPage - 1) * this.search.perPage + index)
      return ((this.search.cursorPage - 1) * this.search.perPage + index) + 1
    },
    handleSearch() {
      this.loadData();
    },
    onChangePage (page) {
      this.search.cursorPage = page;
      this.loadData();
    },
    calcTotal (key) {
      if (this.form.list.length > 0) {
        let sum = 0;
        for (const data of this.form.list) {
          sum += Number(`${data[key]}`);
        }
        return new Intl.NumberFormat().format(sum);
      }
      return 0;
    }
  }
}
</script>

<style scoped>
.table-display {
  display: grid;
  grid-template-rows: repeat(2, minmax(52px, 100%));
}

.table-content {
  display: grid;
  grid-template-rows: minmax(52px, 100%);
  background-color: white;
}

.table-center {
  display: flex;
  height: 100%;
  align-items: center;
  justify-content: center;
  padding: 0 8px;
}
</style>
